import Criteria from './Criteria'

export default class ItemFields extends Criteria{

}